<template>
  <v-container>
    <div class="elevation-2 px-5 mt-3">
      <SimplePageHeader title="Internal Employees" class="px-4 pr-5 mb-5">
        <template v-slot:right-buttons>
          <ButtonCustomIcon
            icon="add"
            color="primary"
            text="Add"
            :routeName="staffCreateRoute.name"
            :block="true"
          />
        </template>
      </SimplePageHeader>
      <StaffFilters
        class="px-5 mb-sm-5"
        :firstNames="firstNames"
        :lastNames="lastNames"
        @search="handleSearchClick"
        @clear="handleSearchClick"
      ></StaffFilters>
    </div>
    <v-container fluid class="px-0 pt-2 mt-4">
      <v-layout column>
        <v-data-table
          dense
          :headers="headers"
          :items="staff"
          class="elevation-2"
        >
          <template v-slot:item.active="{ item }">
            <v-simple-checkbox
              v-model="item.active"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              class="mx-1 my-1"
              color="primary"
              outlined
              @click.prevent="editStaffEmployee($event, item)"
            >
              <v-icon color="primary">edit</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-layout>
    </v-container>
    <BottomSpacer></BottomSpacer>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import StaffFilters from './StaffFilters'
import { staffCreateRoute, staffEditRoute } from '@/lib/constants/routes'
import { BottomSpacer, ButtonCustomIcon } from '@/components/buttons'
import { SimplePageHeader } from '@/components/pageComponents'

export default {
  components: {
    StaffFilters,
    BottomSpacer,
    ButtonCustomIcon,
    SimplePageHeader
  },
  data () {
    return {
      staffCreateRoute,
      staffEditRoute,
      headers: [
        { text: 'First Name', value: 'firstName', width: '35%' },
        { text: 'Last Name', value: 'lastName', width: '35%' },
        { text: 'Active', value: 'active', align: 'center', width: '10%', sortable: false },
        { text: 'Actions', value: 'action', align: 'center', sortable: false, width: '20%' }
      ],
      firstNames: [],
      lastNames: []
    }
  },
  computed: {
    ...mapFields('staff', [
      'staff'
    ]),
    ...mapFields('staffFilters', [
      'firstName',
      'lastName',
      'includeInactive'
    ])
  },
  created () {
    this.getStaff().then((staff) => {
      this.firstNames = staff.map((employee) => { return { firstName: employee.firstName.trim() } })
      this.lastNames = staff.map((employee) => { return { lastName: employee.lastName.trim() } })
      this.firstNames.sort((a, b) => (a.firstName > b.firstName) ? 1 : -1)
      this.lastNames.sort((a, b) => (a.lastName > b.lastName) ? 1 : -1)
      this.staff = this.staff.filter(
        (employee) =>
          employee.firstName.includes(this.firstName ? this.firstName : '') &&
          employee.lastName.includes(this.lastName ? this.lastName : '') &&
          (employee.active || employee.active === !this.includeInactive))
    })
  },
  methods: {
    ...mapActions('staff', [
      'getStaffWithFilters',
      'getStaff'
    ]),
    ...mapActions('staffFilters', [
      'clearFilters'
    ]),
    editStaffEmployee (event, staffEmployee) {
      if (event.ctrlKey === true) {
        let route = this.$router.resolve({ name: staffEditRoute.name, params: { id: staffEmployee.id } })
        window.open(route.href, '_blank')
      } else {
        this.$router.push({ name: staffEditRoute.name, params: { id: staffEmployee.id } })
      }
    },
    handleSearchClick () {
      this.getStaffWithFilters().then(() => {
        this.staff = this.staff.filter(
          (employee) => (employee.active || employee.active === !this.includeInactive))
      })
    }
  }
}
</script>
